/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-08 20:58:06 */

const Keys = {
  select: 'select',
  ascending: 'ascending',
  descending: 'descending',
  sorting: 'sorting',
  showFurtherElements: 'showFurtherElements',
  unAvailableListItem: 'unAvailableListItem'
}; export default Keys;